<form *ngIf="model" (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form mb-10">
    <div [hidden]="!loading" class="spinner">
        <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="form-group">
        <label class="form-label">Status <span class="required">*</span></label>
        <select [(ngModel)]="newStatus" formControlName="status" class="form-control">
            <option *ngFor="let status of statuses" [value]="status.id">{{status.label}}</option>
        </select>
        <input-errors [control]="form.controls.status" [service]="validationService"></input-errors>
    </div>
    <div *ngIf="buttonsShow" class="text-right buttons">
        <a href="javascript:history.back();" class="btn btn-danger m-b m-r">Cancel</a>
        <button id="btn-appscripts-payment-request-apply" type="submit" [disabled]="!form.valid" class="btn btn-primary m-b">Apply</button>
    </div>
</form>
